import React, { useState } from "react";

import OtpTimer from "otp-timer";
import {
  userDetails,
  userLogin,
  userRegistrationOtp,
  userVerifyOtp,
} from "../../../services/MainApiDetails";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { Link } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EnterOtp = ({ VerifyOtp }) => {
  const [otp, setOtp] = useState("");
  const [error,setErrors]=useState("")
  const [message,setMessage]=useState("")

  const [otpSuccess, setOtpSuccess] = useState(false);

  const handleOtpClose = () => {
    setOtpSuccess(false);
  };

  function resendOtpUser() {
    let email = "";
    let phone = "";
    let countryCode = "";

    if (localStorage.email) {
      email = localStorage.email;
    }
    if (localStorage.phone) {
      phone = localStorage.phone;
    }
    userRegistrationOtp({
      phone: phone,
      email: email,
      country_code: localStorage.country_code,
    })
      .then((response) => {
        if (response.data.status === 1) {
          let otpResp = response.data.otp;
        }
      })
      .catch((err, message) => {});
  }
  function verifyUserOtp() {
    let email = "";
    let phone = "";
    let countryCode = "";

    if (localStorage.email) {
      email = localStorage.email;
    }
    if (localStorage.phone) {
      phone = localStorage.phone;
    }

    if (otp)
    {
      localStorage.setItem("otp",otp)

      userVerifyOtp({
        phone: phone,
        email: email,
        country_code: localStorage.country_code,
        otp: parseInt(otp.trim()),
      })
        .then((res) => {
          if (res.data.status === 1) {
            setMessage(res.data.message);
            setOtpSuccess(true);
            VerifyOtp()
            setOtpSuccess(true);
            // VerifyOtp();
          } else {
            setErrors(res.data.message);
          }
        })
        .catch((err, message) => {
          console.log(err + message);
        });
    } else {
      setErrors("please enter otp");
    }
  }

  function continueToReset() {
    VerifyOtp();
  }

  return (
    <div className="mobileForgotPassword-form-wrapper">
      <div className="mobileForgotPassword-form-top">
        <h6>Enter OTP</h6>

        <p>
          {localStorage.language == "en"?"A 6-digit OTP has been sent to your mobile number (only for Indian numbers) and to your email." : "6 അക്കമുള്ള OTP താങ്കളുടെ മൊബൈൽ നമ്പറിലേക്കും (ഇന്ത്യൻ നമ്പറുകൾമാത്രം) ഇ-മെയിലിലേക്കും അയച്ചിട്ടുണ്ട്."
          }
        </p>
      </div>
      <div className="mobileForgotPassword-form-bottom">
        <form action="">
          <div className="mobileForgotPassword-input-wrapper">
            <div className="mobileForgotPassword-inputBox">
              <span>Enter OTP</span>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Type here"
              />
              <span style={{"color":"red"}}>{error}</span>
              <span style={{"color":"green"}}>{message}</span>

            </div>
          </div>

          <div className="mobileForgotPassword-signup-button">
            <button type="button" onClick={verifyUserOtp}>
              CONFIRM
            </button>
          </div>
        </form>
        <div className="mobileForgotPassword-resend-otp">
          <OtpTimer
            minutes={1}
            seconds={1}
            text="Resend OTP in"
            ButtonText="Resend OTP"
            resend={resendOtpUser}
          />
        </div>
      </div>
      <div className="pleaseLoginModal">
        {/* <Button variant="outlined" onClick={handleClickOpen}>
          PLEASE LOG IN
        </Button> */}
        <Dialog
          open={otpSuccess}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleOtpClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <div className="pleaseLoginModal-wrapper">
            <div className="pleaseLoginModal-header">
              <h2>OTP VERIFICATION SUCCESSFULLY</h2>
            </div>

            <div className="pleaseLoginModal-content">
              <p>Please click continue to reset password.</p>
            </div>

            <div className="pleaseLoginModal-button-wrapper">
              {/* <Link to="/mobile-login"> */}
                <Button onClick={continueToReset} className="pleaseLoginModal-login-btn">CONTINUE</Button>
              {/* </Link> */}
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default EnterOtp;
